import { BToast, BSpinner } from 'bootstrap-vue'
import { mapState, mapActions } from 'vuex'
import constants from '@/util/constants'

export default {
  name: 'permissoes',
  components: {
    'b-toast': BToast,
    'b-spinner': BSpinner
  },

  computed: {
    ...mapState('usuarios', ['listaMergeDasPermissoesDoUsuarioESistema', 'formulario', 'flagsDeControle']),
    ...mapState('auth', ['financeiroContratado', 'faturamentoContratado', 'relatoriosContratado'])
  },

  data: () => {
    return {
    }
  },

  mounted () {
  },

  methods: {
    ...mapActions('usuarios', ['ActionDefinirSePossuiNegociador', 'ActionDefinirListaNegociadoresDoUsuario']),

    habilitarAbaNegociadores (permissao) {
      let permissaoId = permissao.f_id
      let permissaoEstaHabilitada = permissao.habilitada
      if (permissaoId === constants.permissaoAcordo.id) {
        if (permissaoEstaHabilitada) {
          this.ActionDefinirSePossuiNegociador(true)
        } else {
          this.ActionDefinirSePossuiNegociador(false)
        }
      }
    },

    verificarAcessoAoFinanceiro () {
      let temAcesso = this.financeiroContratado
      if (!temAcesso) {
        document.getElementById('customSwitchFinanceiro').checked = false
        this.showModalSemAcessoAoFinanceiro()
      }
    },

    showModalSemAcessoAoFinanceiro () {
      this.$bvModal.msgBoxOk('Você não possui este produto contratado. Por favor, entre em contato com a Office.ADV.', {
        buttonSize: 'sm',
        okTitle: 'Ok',
        okVariant: 'outline-primary',
        contentClass: 'text-center'
      })
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    }
  }
}
